export default class SoundManager {

    private scene: Phaser.Scene;
    private static instance: SoundManager | null = null;
    private music: any = null;
    private musicPlayed = '';
    private volume = 0.2;

    private constructor(scene: Phaser.Scene) {
        console.log('SoundManager constructor');
        this.scene = scene;
    }

    static getInstance(scene?: Phaser.Scene): SoundManager {

        if (!SoundManager.instance && scene) {
            SoundManager.instance = new SoundManager(scene);
        }

        if (!SoundManager.instance) {
            throw new Error('SoundManager initialization error: No scene has been provided and no previous instance exists.');
        }

        return SoundManager.instance;
    }

    public playMainMenuMusic(): void {
        this.playMusic('music_menu');
    }
    
    public playGameMusic(): void {
        this.playMusic('music_playing');
    }

    public playWinMusic(): void {
        this.playMusic('music_win');
    }

    public playLoseMusic(): void {
        this.playMusic('music_lose');
    }

    public playEndgameMusic(): void {
        this.playMusic('music_endgame');
    }

    public stopMusic(): void {
        if(this.music) {
            this.music.stop();
        } 
    }

    public resumeMusic(): void {
        if(this.music) {
            this.music.play();
        }
    }

    private playMusic(key: string) {
        if(this.music && this.musicPlayed == key) {
            return;
        }
        if (this.music && this.musicPlayed) {
            this.music.stop();
        }
        this.music = this.scene.sound.add(key, {
            loop: true,
            volume: this.volume
        });
        this.music.play();
        this.musicPlayed = key;
    }

    public setVolume(volume: number): void {
        this.volume = volume;
        if(this.music) {
            this.music.setVolume(volume);
        }
    }

    public playButtonEffect() {
        const soundKey = Math.random() < 0.5 ? 'click_1' : 'click_2';
        this.scene.sound.play(soundKey, {
            volume: this.volume
        });
    }
}